<template>
   <div class="w-table-wrap" style="max-height: 800px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN'" >
            <template #title>
               SENARAI TERNAKAN
               <w-flex justify-end class="mt2">
                  <w-button @click="isMinimizedList = !isMinimizedList">
                     <template v-if="isMinimizedList">
                        <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                     </template>
                     <template v-else>
                        <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                     </template>
                  </w-button>
               </w-flex>
            </template>
         <div v-show="!isMinimizedList" class="space-y-6">
         <div class="w-table-wrap" style="max-height: 1400px;" >
          <div v-show="!isMinimizedList">
           <div style="display: flex; flex-wrap: wrap;">
             <div style="flex-grow: 1;">
               <div style="display: flex; align-items: center; gap: 8px; line-height: 35px;">
              <span style="min-width: 150px;"><b>Tarikh Pemeriksaan</b></span>
              <span style="margin-right: 8px;"><b>:</b></span>
              <div>
                <template v-if="datas.lkp_status_id==34 || datas.lkp_status_id==32 || datas.lkp_status_id==27 || datas.lkp_status_id==44"> 
                  <w-input 
                    type="date" 
                    v-model="datas.tarikh_pemeriksaan" 
                    :validators="[validators.required]" 
                    outline
                  ></w-input>
                </template>
                <template v-else>
                  {{ $zutil.dateformat(datas.tarikh_pemeriksaan) }}
                </template>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px; overflow-x: auto;">
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">BIL</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">NO KES PD</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">ID TERNAKAN/NAMA</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">BAKA</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">TARIKH BERANAK TERDAHULU</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">TARIKH SUNTIKAN TERDAHULU / NAMA JURUTEKNIK/JURUSUNTIK</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">
                  <div style="font-size: 12px;">KAEDAH PEMERIKSAAN <span style="color: red; margin-left: 2px; ">*</span></div>
                </th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">
                  <div style="font-size: 12px;">STATUS <span style="color: red; margin-left: 2px;">*</span></div>
                </th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">USIA KEBUNTINGAN (BULAN)</th>
                <th style="padding: 12px 8px; text-align: center; font-size: 12px;">TARIKH JANGKA BERANAK</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="datas.ternakan_list.length == 0">
                <tr>
                  <td style="padding: 20px; text-align: center; color: #666;" colspan="10">Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in datas.ternakan_list">
                <tr>
                  <td style="padding: 10px 8px; text-align: left;">{{ ind + 1 }}</td>
                  <td style="padding: 10px 8px; text-align: left;">{{ dt.no_kes }}</td>
                  <td style="padding: 10px 8px; text-align: left;">{{ dt.ternakan_nama }}</td>
                  <td style="padding: 10px 8px; text-align: left;">{{ dt.baka }}</td>
                  <td style="padding: 10px 8px; text-align: left;">{{ dt.tarikh_beranak_terdahulu }}</td>
                  <td style="padding: 10px 8px; text-align: left;">
                    {{ $zutil.dateformat(dt.tarikh_suntik_terdahulu) }} | {{ dt.nama_juruteknik_terdahulu }}
                  </td>
                  <td style="padding: 10px 8px; text-align: left; width: auto; white-space: nowrap;">
                 <template v-if="datas.lkp_status_id==35 || datas.lkp_status_id==18 || datas.lkp_status_id==28||datas.lkp_status_id==40">
                   {{ dt.lkpKaedahPemeriksaan_keterangan }}
                 </template>
                 <template v-else>
                   <w-select 
                     placeholder="Pilih Satu.." 
                     outline 
                     :items="lkp_kaedah_pemeriksaan" 
                     v-model="dt.lkp_kaedah_pemeriksaan_id" 
                     :validators="[validators.required]" 
                     :readonly="datas.lkp_status_id==21 || datas.lkp_status_id==30 || datas.lkp_status_id==31"
                     style="width: auto; min-width: 150px;"
                     :disabled="!datas.tarikh_pemeriksaan"
                   />
                 </template>
               </td>
               <td style="padding: 10px 8px; text-align: left; width: auto; white-space: nowrap;">
                 <template v-if="datas.lkp_status_id==35 || datas.lkp_status_id==18 || datas.lkp_status_id==28 ||datas.lkp_status_id==40">
                   <template v-if="dt.bunting==1">BUNTING</template>
                   <template v-else>TIDAK BUNTING</template>
                 </template>
                 <template v-else>
                   <w-select 
                     placeholder="Pilih Satu.." 
                     outline 
                     :items="bunting" 
                     @input="getTarikhJangkaan(dt, dt.usia_bunting)" 
                     v-model="dt.bunting" 
                     :validators="[validators.required]" 
                     :readonly="datas.lkp_status_id==21 || datas.lkp_status_id==30 || datas.lkp_status_id==31"
                     style="width: auto; min-width: 120px;"
                     :disabled="!datas.tarikh_pemeriksaan"
                   />
                 </template>
               </td>
                  <td style="padding: 10px 8px; text-align: right; ">
                    <template v-if="datas.lkp_status_id==35 || datas.lkp_status_id==18 || datas.lkp_status_id==28 ||datas.lkp_status_id==40">
                      {{ dt.usia_bunting }}
                    </template>
                    <template v-else>
                      <w-input 
                        min="0" 
                        placeholder="Sila masukan.." 
                        outline 
                        v-model="dt.usia_bunting" 
                        :validators="[validators.required, validators.numeric]" 
                        @change="getTarikhJangkaan(dt, dt.usia_bunting)" 
                        :disabled="dt.bunting==2 || datas.lkp_status_id==21 || datas.lkp_status_id==30 || datas.lkp_status_id==31 || !datas.tarikh_pemeriksaan"
                      />
                    </template>
                  </td>
                  <td style="padding: 10px 8px; text-align: center;">{{ $zutil.dateformatBulanTahun(dt.jankaan_kelahiran) }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      </div>

        <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34||datas.lkp_status_id==27||datas.lkp_status_id==32 || datas.lkp_status_id==44 )&& $zutil.anyRole(['7', '8', '9', '10','4'])">
         <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button class="my1" type="submit" v-on="on" :disabled="loading||datas.tarikh_pemeriksaan==null " :loading="loading" ><div style="width: 8px"></div> 
                     <!-- <w-icon md class="mr2">fal fa-save</w-icon> -->SIMPAN
                 </w-button>
                 </template>
                SIMPAN
               </w-tooltip>
          &nbsp;
          <!-- <w-button class="my1" bg-color="success" type="submit" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button> -->
        </w-flex>
      </div>
   </w-card>
</w-form>
</div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.pd-aiman',
      form : {},
      datas : this.d_data,
      lkp_kaedah_pemeriksaan : [],
      loading:false,
      isMinimizedList :false,

      bunting:[
        {value: 1, label: "BUNTING"},
        {value: 2, label: "TIDAK BUNTING"}
      ],
      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      validators: {
          required: (value) => value !== null && value !== undefined && value !== '' || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      
    }
  },
  methods:{
    calculateDueMonth(currentDate, pregnancyDays, monthsCompleted) {
        // kiraan by bulan
        const averageDaysPerMonth = pregnancyDays / 9;
        const daysElapsed = monthsCompleted * averageDaysPerMonth;
        const remainingDays = pregnancyDays - daysElapsed;
        const dueDate = new Date(currentDate);
        dueDate.setDate(dueDate.getDate() + remainingDays);
        // const dueMonth = dueDate.toLocaleString('default', { month: 'long' });
        // const dueYear = dueDate.getFullYear();

        // return `1 ${dueMonth} ${dueYear}`;
        const yyyy = dueDate.getFullYear();
        const mm = String(dueDate.getMonth() + 1).padStart(2, '0');
        const dd = String(dueDate.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    },
    getTarikhJangkaan(dt, usia_bunting){

      if(dt.bunting==1){
        const bunting_ternakan = this.datas.bunting_ternakan;
        const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);

        // kiraan by hari
        // const totalhari = bunting_ternakan - usia_bunting;
        // tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + totalhari);
        // const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;

        dt.jankaan_kelahiran = this.calculateDueMonth(tarikh_pemeriksaan, bunting_ternakan, usia_bunting); 
      }else{
         dt.jankaan_kelahiran=null;
        dt.usia_bunting =0;
      }
    },
    lkpKaedahPemeriksaan()
    {
      this.$zcomm.get(this.api_service + 'lookup/kaedah_pemeriksaan', {}).then(res => {
        this.lkp_kaedah_pemeriksaan = res
      })
    },
    validateForm() {
      this.loading = true;
      let isValid = true;

      this.datas.ternakan_list.forEach((row) => {
        if (
            !row.lkp_kaedah_pemeriksaan_id || 
            row.lkp_kaedah_pemeriksaan_id == 0 || 
            !row.bunting || 
            (row.bunting == 1 && (!row.usia_bunting || row.usia_bunting == 0))
        ) {
          isValid = false;
        }
      });

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data (Kaedah Pemeriksaan, Status, Usia) sudah diisi dengan betul.", false);
        this.loading = false;
        return false;
      }
      
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    
    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.datas.ternakan_list, pemeriksaan:1, hantar:1,tarikh_pemeriksaan:this.datas.tarikh_pemeriksaan})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('pd.permohonan.show', this.datas.id));
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('pd.permohonan.show', this.datas.id));
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.datas.ternakan_list, pemeriksaan:1, tarikh_pemeriksaan:this.datas.tarikh_pemeriksaan})
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('pd.permohonan.show', this.datas.id));
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('pd.permohonan.show', this.datas.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
    this.lkpKaedahPemeriksaan()
    // this.datas = this.data;
  }
}
      

</script>  
<style scoped>
</style>
